import React from 'react';
import PaginationItem from './PaginationItem';

export const getNeighboringPages = (currentPage, totalPages) => {
  const start = Math.max(1, currentPage - 1);
  const end = Math.min(totalPages, start + 2);

  const result = [];
  for (let i = start; i <= end; i++) {
    result.push(i);
  }

  while (result.length < 3 && result[0] > 1) {
    result.unshift(result[0] - 1);
  }

  while (result.length < 3 && result[result.length - 1] < totalPages) {
    result.push(result[result.length - 1] + 1);
  }

  return result;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const neighboringNumbers = getNeighboringPages(currentPage, totalPages);

  const handlePrevPageChange = () => {
    if (currentPage === 1) return;
    onPageChange(currentPage - 1);
  };

  const handleNextPageChange = () => {
    if (currentPage === totalPages) return;
    onPageChange(currentPage + 1);
  };

  return (
    <div className="flex gap-[10px] justify-center items-center h-[37px]">
      {neighboringNumbers.length > 1 && (
        <>
          <PaginationItem className="min-w-[58px]" text={'Prev'} disabled={currentPage === 1} onClick={handlePrevPageChange} />
          <PaginationItem
            className="min-w-[58px] md:flex hidden"
            disabled={currentPage === totalPages}
            text={'First'}
            onClick={() => onPageChange(1)}
          />{' '}
        </>
      )}

      {!neighboringNumbers.includes(1) && neighboringNumbers.length > 0 && (
        <div
          disabled={true}
          className="min-w-[31px] border-1 flex items-center justify-center h-full rounded-[5px] border-[#D9A8E5] text-[18px] text-[#D9A8E5] font-[400] leading-[22px] select-none"
        >
          ...{' '}
        </div>
      )}
      {neighboringNumbers.map(number => (
        <PaginationItem
          className="min-w-[31px]"
          active={currentPage === number}
          key={number}
          text={number}
          onClick={() => currentPage !== number && onPageChange?.(number)}
        />
      ))}
      {!neighboringNumbers.includes(totalPages) && neighboringNumbers.length > 0 && (
        <div
          disabled={true}
          className="min-w-[31px] border-1 flex items-center justify-center h-full rounded-[5px] border-[#D9A8E5] text-[18px] text-[#D9A8E5] font-[400] leading-[22px] select-none"
        >
          ...{' '}
        </div>
      )}
      {neighboringNumbers.length > 1 && (
        <>
          <PaginationItem
            className="min-w-[58px] md:flex hidden"
            disabled={currentPage === totalPages}
            text={'Last'}
            onClick={() => onPageChange(totalPages)}
          />
          <PaginationItem className="min-w-[58px]" disabled={currentPage === totalPages} text={'Next'} onClick={handleNextPageChange} />
        </>
      )}
    </div>
  );
};

export default Pagination;
